import React from 'react'
import MainAboutCard from '../main/MainAboutCard'
import Link from 'next/link'
import { useTranslation } from 'react-i18next'

const icon = (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M19.2 10C19.2 15.081 15.081 19.2 10 19.2C4.91898 19.2 0.8 15.081 0.8 10C0.8 4.91898 4.91898 0.8 10 0.8C15.081 0.8 19.2 4.91898 19.2 10Z" stroke="#83A3EB" stroke-width="1.6" stroke-miterlimit="10" />
        <path d="M10 7C10.5523 7 11 6.55228 11 6C11 5.44772 10.5523 5 10 5C9.44772 5 9 5.44772 9 6C9 6.55228 9.44772 7 10 7Z" fill="#83A3EB" />
        <path d="M10 9L10 11.65L10 14.6" stroke="#83A3EB" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
)

interface IProps { }

export const B2BIntro: React.FC<IProps> = () => {
    const {t} = useTranslation()

    const data = {
        tag: t('aboutCompanyLower'),
        title: t('MegamixGroup'),
        text: [
            t("b2bText1"),
            t("b2bText2")
        ]
    }

    const scrollToChapter = chapterId => () => {
        const element = document.getElementById(chapterId)

        if (element) {
            element.scrollIntoView({ behavior: 'smooth' })
        }
    }

    return (
        <div className='b2b__intro'>
            <div>
                <Link
                    href={'/#map-cards'}
                    style={{ position: 'relative', zIndex: 2, height: 'auto' }}
                >
                    <button className='buttons buttons__maps'>
                        <svg
                            width='19'
                            height='19'
                            viewBox='0 0 19 19'
                            fill='none'
                            xmlns='http://www.w3.org/2000/svg'
                        >
                            <g opacity='0.6'>
                                <path
                                    d='M1 3.34483L5.95833 1V15.6552L1 18V3.34483Z'
                                    stroke='#CBD9F9'
                                    strokeWidth='1.6'
                                    strokeLinecap='round'
                                    strokeLinejoin='round'
                                />
                                <path
                                    d='M12.3334 3.34483L18 1V15.6552L12.3334 18V3.34483Z'
                                    stroke='#CBD9F9'
                                    strokeWidth='1.6'
                                    strokeLinecap='round'
                                    strokeLinejoin='round'
                                />
                                <path
                                    d='M12.3334 3.34483L5.95837 1V15.6552L12.3334 18V3.34483Z'
                                    stroke='#CBD9F9'
                                    strokeWidth='1.6'
                                    strokeLinecap='round'
                                    strokeLinejoin='round'
                                />
                            </g>
                        </svg>
                        {t("BackToMap")}
                    </button>
                </Link>
            </div>
            <div className='main__order'>
                <div className='main-about__card-content'>
                    <MainAboutCard item={data} />
                    <div className='main-about__card-buttons'>
                        <button
                            onClick={scrollToChapter('b2b-today')}
                            className='main__order-button main__card-button'
                        >
                            {icon}
                            <p>{t("details")}</p>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}
